/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolNewStateTransitionConfig,
    ISymbolOldStateTransitionConfig,
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {HarlequinGameConfig} from "../HarlequinGameConfig";
import Sprite = PIXI.Sprite;

export interface IHarlequinSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    nudge:ISymbolStateConfig;
}


// TODO: CLEAN UP AFTER NUDGE BEHAVIOR IS PROPER
export class HarlequinReelSymbol extends StateReelSymbol {

    protected stackedNudgeSprite:Sprite | null;
    protected stackedNudgeSpine:PIXI.spine.Spine | null;

    //protected stackWildWinSprite:Sprite | null;
    //protected stackWildWinSpine:PIXI.spine.Spine | null;


    protected _currentMultiplier:number = 1;

    protected symSpineSprite:Sprite;
    protected symSpine:PIXI.spine.Spine;

    protected symWinSprite:Sprite;
    protected symWinSpine:PIXI.spine.Spine | null;

    protected _nudgeSteps:number = 0;

    protected _stackWinSpines:PIXI.spine.Spine [] = [];


    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected initAnimations():void {
        this._stackWinSpines = [];

        if(!this.symSpineSprite && this.symName === "S") {
            this.symSpineSprite = this.createScatterSprite();
            this.symSpine = this.createScatterSpine("scatterSpine");

            this.symSpineSprite.addChild(this.symSpine);
        }

        if(!this.symSpineSprite && this.symName === "S2") {
            this.symSpineSprite = this.createScatterSprite();
            this.symSpine = this.createScatterSpine("scatterWildSpine");

            this.symSpineSprite.addChild(this.symSpine);
        }

        if(!this.stackedNudgeSprite && this.stackedSymName && this.stackedSymName.index > -1 && this.stackedSymName.index < 3) {
            if(["W*0", "W*1", "W*2"].indexOf(this.symName) > -1) {
                this.stackedNudgeSprite = this.createStackedSprite();
                this.stackedNudgeSpine = this.createStackedSpine();
                this.stackedNudgeSpine.y = -200;
                this.stackedNudgeSprite.addChild(this.stackedNudgeSpine);
                this.addChild(this.stackedNudgeSprite);

                this.playStackedLand();
            }
        }

        /*[0,1,2].forEach((value) => {
            //"WildInitialWinOnNonWiningPart"
            this.playStackWin(value);
        });*/

    }

    protected createStackWinSpine(value:number, noWin:boolean = false):PIXI.spine.Spine {
        //const sprite:Sprite = new Sprite();
        const spine:PIXI.spine.Spine = this.createStackWildWinSpine(value);
        spine.scale.set(1, 1);

        //spine.state.setAnimation(0, "WildInitialWin", true);

        //spine.position.set(0, -(value * 182.5) + ((value * -6.5)));


        //sprite.addChild(spine);
        if(this.stackedNudgeSprite) {
            this.stackedNudgeSprite.addChild(spine);
        }
        /*else {
            this.stackedNudgeSprite = this.createStackedSprite();
            this.stackedNudgeSprite.addChild(spine);
        }*/

        if(!noWin) {
            if(value === 0) {
                spine.position.set(0, -390);
            } else if(value === 1) {
                spine.position.set(0, -190);
            } else if(value === 2) {
                spine.position.set(0, 10);
            }
        } else {
            if(value === 0) {
                spine.position.set(0, -380);
            } else if(value === 1) {
                spine.position.set(0, -185);
            } else if(value === 2) {
                spine.position.set(0, 10);
            }
        }

        return spine;
    }

    public playStackWin(position:number):void {
        //debugger;
        if(position > -1) {
            const spine:PIXI.spine.Spine = this.createStackWinSpine(position);
            if(this.stackedNudgeSprite) {
                this.addChild(this.stackedNudgeSprite);
            }
            spine.state.setAnimation(0, "WildInitialWin", false);
        }
    }

    public playStackNoWin(position:number):void {
        if(position > -1) {
            const spine:PIXI.spine.Spine = this.createStackWinSpine(position, true);
            spine.state.setAnimation(0, "WildInitialWinOnNonWiningPart", false);
        }
    }

    protected createStackWildWinSpine(symId:number):PIXI.spine.Spine {
        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("stackWildWinSpine"));

        spine.name = "sym" + symId;
        spine.autoUpdate = true;
        spine.scale.set(1, 1);

        return spine;
    }

    protected createSymWinSprite():Sprite {
        const sprite:Sprite = new Sprite();
        sprite.anchor.set(0.5, 0.5);
        sprite.name = "WIN_SPRITE";

        return sprite;
    }


    protected createSymWinSpine(symName:string, animName:string):PIXI.spine.Spine {
        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(symName + "Spine"));

        spine.name = "symWinSpine";
        spine.autoUpdate = true;
        //spine.state.setAnimation(0, symName + animName, true);

        return spine;
    }

    /*protected createStackWildWinSpine():PIXI.spine.Spine {
        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("stackWildWinSpine"));

        spine.name = "stackWildWin";
        spine.autoUpdate = true;

        return spine;
    }*/

    public playSymWinSpine(animName:string = "WildInitialWin", loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void, create:boolean = false):void {
        if(create) {
            this.symWinSprite = this.createSymWinSprite();
            this.symWinSpine = this.createSymWinSpine(this.symName, "idle");
        }

        if(this.symWinSpine && this.symWinSprite) {
            this.symWinSpine.state.setAnimation(0, this.symName + animName, loop);

            if(onComplete) {
                // Add callback to listener
                this.symWinSpine.state.addListener({
                    //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                    complete : (entry) => onComplete(entry)
                    //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                    //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
                });
            }
        }
    }

    /*protected playWildWinSpine(winName:string, loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void):void {
        if(this.stackWildWinSpine) {
            this.stackWildWinSpine.state.setAnimation(0, winName, loop);

            if(onComplete) {
                // Add callback to listener
                this.stackWildWinSpine.state.addListener({
                    //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                    complete: (entry) => onComplete(entry)
                    //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                    //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
                });
            }
        }
    }*/

    protected createScatterSprite():Sprite {
        const sprite:Sprite = new Sprite();
        sprite.anchor.set(0.5, 0.5);
        sprite.name = "SCATTER_SPINE_SPRITE";

        return sprite;
    }

    protected createScatterSpine(spineName:string):PIXI.spine.Spine {
        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(spineName));

        spine.name = "scatterSpine";
        spine.autoUpdate = true;
        spine.state.setAnimation(0, "scatterIdle", true);

        return spine;
    }

    public playSymSpineAnimation(name:string, loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void):void {

        this.symSpine.state.setAnimation(0, name, loop);

        if(onComplete) {
            // Add callback to listener
            this.symSpine.state.addListener({
                //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                complete : (entry:PIXI.spine.core.TrackEntry) => onComplete(entry),
                /*start: (entry:PIXI.spine.core.TrackEntry) => {
                    debugger;
                    if (entry.animation.name == "scatterLandingAttention") {
                        if(this.symName === "S") {
                            HarlequinGameModuleConfig.harlequinScatterCollectorView.playScatterLandSound();
                            console.log("PLAYING ATT!");
                            console.log(this);
                        }
                    }
                }*/
                //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
            });
        }
    }


    protected createStackedSprite():Sprite {
        const sprite = new Sprite();
        sprite.anchor.set(0.5, 0.5);
        sprite.name = "SPINE_SYM_SPRITE";
        //sprite.visible = false;

        return sprite;
    }

    protected createStackedSpine():PIXI.spine.Spine {
        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildWalker"));

        spine.name = "spine";
        spine.autoUpdate = true;
        this.stackedNudgeSpine = spine;
        this.stackedNudgeSpine.state.setAnimation(0, "X1Idle", false);

        //this.setSpineY();

        return spine;
    }

    onRemove() {
        super.onRemove();

        if(this.stackedNudgeSprite) {
            if(this.stackedNudgeSpine) {
                this.stackedNudgeSprite.removeChild(this.stackedNudgeSpine);
            }
            this.removeChild(this.stackedNudgeSprite);
            this.stackedNudgeSprite = null;
            this.stackedNudgeSpine = null;
        }

    }

    protected setSpineY():void {
        if(this.stackedNudgeSpine) {


            switch(this._nudgeSteps) {
                case -2:
                    //console.log("NUDGE STEPS " + this._nudgeSteps);
                    if(this.symName.indexOf("W") > -1) {
                        //this.stackedNudgeSpine.y = -100;
                        this._nudgeSteps = 0;
                    } else {
                        //console.log("NOT W: " + this.symName);
                        //this.stackedNudgeSpine.y = 100;
                        this._nudgeSteps = 0;
                    }
                    break;
                case -1:
                    console.log("NUDGE STEPS " + this._nudgeSteps);
                    break;
                case 0:
                    console.log("NUDGE STEPS " + this._nudgeSteps);
                    break;
                case 1:
                    console.log("NUDGE STEPS " + this._nudgeSteps);
                    break;
                case 2:
                    console.log("NUDGE STEPS " + this._nudgeSteps);
                    break;
            }
        }
    }

    public updateMpValue(value:number):void {
        this._currentMultiplier = value;
    }

    public playNudgeSpine(mpValue:number):void {
        if(this.stackedNudgeSprite) {
            this.stackedNudgeSprite.visible = true;

            if(this.stackedNudgeSpine) {
                this.stackedNudgeSpine.state.setAnimation(0, "X" + mpValue, false);
            }

            //this.setSpineY();
        }
    }

    public playStackedSpin():void {
        if(this.stackedNudgeSprite) {
            this.stackedNudgeSprite.visible = true;
            if(this.stackedNudgeSpine) {
                //console.log(HarlequinGameModuleConfig.CURRENT_MODE);
                this.stackedNudgeSpine.state.setAnimation(0, "spinning", true);
            }

            //this.setSpineY();
        }
    }

    public playStackedLand():void {
        if(this.stackedNudgeSprite) {
            this.stackedNudgeSprite.visible = true;
            if(this.stackedNudgeSpine) {
                this.stackedNudgeSpine.state.setAnimation(0, "landingAttention", false);
            }
        }
    }

    public playIdleSpine(mpValue:number):void {
        if(this.stackedNudgeSprite) {
            const mp:number = (mpValue > 0) ? mpValue : 1;
            this.stackedNudgeSprite.visible = true;
            if(this.stackedNudgeSpine) {
                this.stackedNudgeSpine.state.setAnimation(0, "X" + mp + "Idle", false);
            }

            //this.setSpineY();
        }
    }

    /*public playNoWinWildStack(animName:string):void {
        if(!this.stackWildWinSpine && !this.stackWildWinSprite) {
            this.stackWildWinSpine = this.createStackWildWinSpine();
            this.stackWildWinSprite = new Sprite();
            if(this.stackWildWinSprite && this.stackWildWinSpine) {
                this.stackWildWinSprite.addChild(this.stackWildWinSpine);
                this.addChild(this.stackWildWinSprite);
            }

            this.playWildWinSpine(animName, true);
        }
    }*/

    public playScatterAttention(isFreespin:boolean = false):void {
        if(this.symName === "S" || this.symName === "S2") {
            if(this.symName === "S2") {
                this.children.forEach((sprite) => {
                    if(sprite.name !== "SCATTER_SPINE_SPRITE") {
                        //sprite.visible = false;
                    }
                });
                this.playSymSpineAnimation("+1spin", true, (entry:PIXI.spine.core.TrackEntry) => {
                    if(entry.animation.name == "+1spin") {
                        //this.playSymSpineAnimation("scatterIdle", true);
                    }
                });
            } else {
                this.playSymSpineAnimation("scatterLandingAttention", false, (entry:PIXI.spine.core.TrackEntry) => {
                    if(entry.animation.name == "scatterLandingAttention") {
                        this.playSymSpineAnimation("scatterIdle", true);

                    }
                });
            }
        }
        /*
        else if(this.stackedSymName) {
            debugger;
            this.playStackedLand();
        }*/
    }

    changeState(newStateConfig:ISymbolNewStateTransitionConfig, oldStateConfig?:ISymbolOldStateTransitionConfig, nudgeSteps?:number):Timeline | null {

        if(nudgeSteps) {
            this._nudgeSteps = nudgeSteps;
        }

        return super.changeState(newStateConfig, oldStateConfig);
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        if(this.currentState && this.currentState.keyword === "spin" && newState.state.keyword === HarlequinGameConfig.instance.SYMBOL_STATES.normal.keyword
            && ["W*0", "W*1", "W*2", "W0", "W", "W1", "W2"].indexOf(this.symName) > -1) {
            timeline.add(() => {
                if(this.stackedNudgeSprite) {
                    timeline.add(() => {
                        if(this.stackedNudgeSprite) {
                            this.setChildIndex(this.stackedNudgeSprite, this.children.length - 1);
                        }
                    });
                }

                this.children.forEach((sprite) => {
                    if(sprite.name !== "SPINE_SYM_SPRITE") {
                        //sprite.visible = false;
                    }
                });

                this.playStackedLand();
            });

            return;
        }

        if(this.currentState && this.currentState.keyword === "nudge" && newState.state.keyword === HarlequinGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            timeline.add(() => {
                if(this.stackedNudgeSprite) {
                    timeline.add(() => {
                        if(this.stackedNudgeSprite) {
                            this.setChildIndex(this.stackedNudgeSprite, this.children.length - 1);
                        }
                    });
                }

                if(this.stackedNudgeSprite) {
                    this.children.forEach((sprite) => {
                        if(sprite.name !== "SPINE_SYM_SPRITE") {
                            //sprite.visible = false;
                        }
                    });
                }
            });
            return;
        }

        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(this.currentState && this.currentState.keyword === "spin" && this.stackedSymName && this.stackedSymName.isStacked) {
            if(this.stackedNudgeSprite && ["W*0", "W*1", "W*2"].indexOf(this.symName) > -1 /*&& this.stackedSymName.totalNum === 3 && this.stackedSymName.index === 0 && this.symName === "W*0"*/) {

                timeline.add(() => {
                    if(this.stackedNudgeSprite) {
                        timeline.add(() => {
                            if(this.stackedNudgeSprite) {
                                this.setChildIndex(this.stackedNudgeSprite, this.children.length - 1);
                            }
                        });
                    }

                    if(this.stackedNudgeSprite) {
                        this.children.forEach((sprite) => {
                            if(sprite.name !== "SPINE_SYM_SPRITE") {
                                //sprite.visible = false;
                            }
                        });
                    }
                    this.playStackedSpin();
                }, delay)
            }
        }

        // TODO: Probably moveentire handling to be triggered via reelstop instead
        if(this.currentState && this.currentState.keyword === "spin" && (this.symName === "S" || this.symName === "S2")) {

            if(this.symSpineSprite) {
                timeline.add(() => {
                    this.children.forEach((sprite) => {
                        if(sprite.name !== "SCATTER_SPINE_SPRITE") {
                            //sprite.visible = false;
                        }
                    });

                    this.addChild(this.symSpineSprite);
                    if(newState.state.keyword === HarlequinGameConfig.instance.SYMBOL_STATES.normal.keyword) {
                        this.playSymSpineAnimation("scatterLandingAttention", false, (entry:PIXI.spine.core.TrackEntry) => {
                            if(entry.animation.name == "scatterLandingAttention") {
                                this.playSymSpineAnimation("scatterIdle", true);
                            }
                        });
                    }
                });
            }
        }

        if(newState.state.keyword === HarlequinGameConfig.instance.SYMBOL_STATES.win.keyword && ["W*0", "W*1", "W*2", "W0", "W", "W1", "W2"].indexOf(this.symName) < 0) {
            const winTl:TimelineLite = new TimelineLite();

            if(["L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4", "M5"].indexOf(this.symName) > -1 && !this.symWinSprite) {
                this.symWinSprite = this.createSymWinSprite();
                this.symWinSpine = this.createSymWinSpine(this.symName, "idle");


                winTl.add(() => {
                    //debugger;
                    if(this.symWinSprite && this.symWinSpine) {
                        this.symWinSprite.addChild(this.symWinSpine);
                        this.addChild(this.symWinSprite);
                        this.children.forEach((sprite) => {
                            if(sprite.name !== "WIN_SPRITE") {
                                sprite.visible = false;
                            }
                        });
                        this.playSymWinSpine("InitialWin", false, (entry:PIXI.spine.core.TrackEntry) => {
                            if(entry.animation.name === this.symName + "InitialWin") {
                                //if(this.symName === "M1") {
                                //this.playSymWinSpine("togelWin", true);
                                //}
                                //if(this.symName === "L1") {
                                this.playSymWinSpine("togleWin", true);
                                //}
                            }
                        });
                    }
                });
                winTl.add(() => {}, 0.3);
            } else {
                winTl.add(new TweenLite(this.scale, 0.2, {x : 1, y : 1}));
                winTl.add(() => new TweenLite(this.scale, 0.2, {x : 1, y : 1, delay : 0.3}));
            }


            timeline.add(winTl, delay);
            return;
        } else if(newState.state.keyword === HarlequinGameConfig.instance.SYMBOL_STATES.win.keyword && this.stackedSymName && this.stackedSymName.isStacked/*["W*0", "W*1", "W*2", "W", "W0", "W1", "W2"].indexOf(this.symName) > -1*/) {
            // TODO: Temp! Solution
            //console.log("WIN SYMNAME: " + this.symName);

            timeline.add(() => {
                //debugger;
                this.children.forEach((sprite) => {
                    //if(sprite.name !== "SPINE_SYM_SPRITE") {
                    //sprite.visible = false;
                    //}
                });
                if(this.stackedNudgeSprite) {
                    this.setChildIndex(this.stackedNudgeSprite, this.children.length - 1);
                }
                this.playIdleSpine(this._currentMultiplier);
            }, delay);
            return;
        }

        if(newState.state.keyword === HarlequinGameConfig.instance.SYMBOL_STATES.nudge.keyword) {
            timeline.add(() => {
                //this.setSpineY();
                this._nudgeSteps = 0;
                if(this.stackedNudgeSprite) {
                    this.setChildIndex(this.stackedNudgeSprite, this.children.length - 1);
                }
                if(this.stackedNudgeSprite) {
                    this.children.forEach((sprite) => {
                        if(sprite.name !== "SPINE_SYM_SPRITE") {
                            //sprite.visible = false;
                        }
                    });
                }
            });
            return;
        }

        if(newState.state.keyword === HarlequinGameConfig.instance.SYMBOL_STATES.normal.keyword) {

            //this.playScatterAttention(true);

            if(this.symSpineSprite) {
                timeline.add(() => {
                    this.addChild(this.symSpineSprite);
                });

            }

            if(this.symWinSprite) {
                timeline.add(() => {
                    this.addChild(this.symWinSprite);
                });

            }

            if(this.stackedNudgeSprite) {
                timeline.add(() => {
                    if(this.stackedNudgeSprite) {
                        this.setChildIndex(this.stackedNudgeSprite, this.children.length - 1);
                    }
                });
            }

            if(this.symSpine && newState.state.keyword !== HarlequinGameConfig.instance.SYMBOL_STATES.spin!.keyword) {
                //console.log("adding tint");
                this.symSpine.tint = 0xFFFFFF;
            }

            return;
        }

        if(newState.state.keyword === HarlequinGameConfig.instance.SYMBOL_STATES.noWin!.keyword) {
            if(this.symSpine) {
                //console.log("adding tint");
                this.symSpine.tint = 0x555555;
            }
        } else {
            if(this.symSpine) {
                //console.log("adding tint");
                this.symSpine.tint = 0xFFFFFF;
            }
        }

    }
}